import {history} from '../store/index';
import {store} from '../../NextApp';
import {generateQueryString} from "../../util/Api";

import {
  CREATE_FUEL_TYPE_SUCCESS,
  FETCH_FUEL_TYPE_SUCCESS,
  GET_FUEL_TYPE_SUCCESS,
  SAVE_FUEL_TYPE_QUERY
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import {fetchError, fetchFilter, fetchStart, fetchSubElementFilter, fetchSuccess} from "./Common";
import {getUser} from "./Auth";
import {message} from "antd";
import {arrayToCSV, downloadCSV} from "../../util/methods";


export const getResourceSuccess = ({data, count}) => {
  return {
    type: GET_FUEL_TYPE_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_FUEL_TYPE_QUERY,
    query
  };
};

export const createResourceSuccess = ({data}) => {
  return {
    type: CREATE_FUEL_TYPE_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({data}) => {
  return {
    type: FETCH_FUEL_TYPE_SUCCESS,
    data
  };
};


export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {fuelType} = store.getState();
      const {query} = fuelType;
      const response = await axios.get(`/fuel-type?${generateQueryString(query)}`);

      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      // message.error(error.response.data.message);
      message.error("Record not found");
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {fuelType} = store.getState();
      const {query} = fuelType;
      const response = await axios.get(`/fuel-type/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const createResource = (payload, redirect= true, module, subMaster=false) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.post(`/fuel-type`, payload);
      if(response && response.data && response.data.code === 202){
        message.error(response.data.message);
      } else {
        dispatch(fetchSuccess());
        dispatch(createResourceSuccess({data: response.data}));
      }

      if (!redirect) {
        if (subMaster) {
          dispatch(fetchSubElementFilter(module));
        } else {
          dispatch(fetchFilter(module));
        }
      } else {
        history.push('/fuel-type');
        dispatch(getResource());
      }
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response= await axios.put(`/fuel-type/${id}`, payload);
      if (response && response.data && response.data.code === 202){
        message.error(response.data.message);
      }
      dispatch(fetchSuccess());
      dispatch(getUser());
      history.push('/fuel-type');
      dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};


export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/fuel-type/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({data: response.data}));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.delete(`/fuel-type/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};
